import { Roles } from '../../utils/enums'
import { Http } from '../../utils/types'
import { GetBlob, ObjectGeneric } from '../../utils/types/generals'
import { getUserRole } from '../auth'
import { GetAllZones, GetAllZonesWithFilter, ResponseZones, TimeZone, Zones } from './response'

export const zonesService = (client: Http) => ({
  getAllZones: async (): Promise<GetAllZones> => {
    switch (getUserRole()) {
      case Roles.SUPPORT:
      case Roles.AUDIT:
      case Roles.AGENT:
        return await client.get('zones/store-associate')
      case Roles.STORE:
      case Roles.PARTNER:
        return []
      default:
        return await client.get('zones')
    }
  },
  getAllZonesWithFilter: async (query?: string): Promise<GetAllZonesWithFilter> => {
    return await client.get(`zones${query ? '?' + query : ''}`)
  },
  getParentZones: async (query?: string): Promise<GetAllZones> => {
    return await client.get(`zones?zone_parent=true`)
  },
  getZoneById: async (id: string): Promise<Zones>  => await client.get(`zones/${id}`),
  getTimeZone: async (): Promise<TimeZone[]> => await client.get('time-zones/'),
  createZones: async (body: ObjectGeneric): Promise<ResponseZones> => await client.post('zones', body),
  updateZones: async (body: ObjectGeneric, id: number): Promise<ResponseZones> => await client.put(`zones/${id}`, body),
  deleteZones: async (id: number): Promise<ResponseZones> => await client.delete(`zones/${id}`),
  downloadFile: async (data: {
    type: string
    query?: string
  }): Promise<GetBlob> =>
    await client.getBlob?.(
      `zones/generate-file${data.query ? '?' + data.query + '&type=' + data.type : '?type=' + data.type}`
    ),
})